import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AuthService } from '../../auth/auth.service';
import { SnackBarService } from '../../common-services/snack-bar.service';
import { FormServices, PasswordValidator } from '../../common-services/validators.service';
import { SharedService } from '../../shared/shared.service';
import { API_ENDPOINTS } from '../../common-services/constants.service';
import { AesCryptoService } from '../../common-services/aes-crypto.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {

  IsLogout = false;
  registerForm: FormGroup;
  UserId = '';
  userData: any;
  constructor(public dialogRef: MatDialogRef<ChangePasswordComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sharedService: SharedService,
    private aes: AesCryptoService,         /*~~~~~~~~~~~~~~~  Nidhi Bhosale 2026-03-30 PMSID(zota/netcore/cpos/cpos_web_angular): 9857*/
    private authService: AuthService,
    private notification: SnackBarService,
    private fb: FormBuilder) {
    this.UserId = data.selectedUser.id;
    this.userData = data.selectedUser;
    this.IsLogout = data.isLogOut;
    if (this.IsLogout == false) {
      this.registerForm = this.fb.group({
        id: [this.UserId],
        newPassword: [null, Validators.compose([Validators.required, PasswordValidator.strong])],
        confirmPassword: [null, Validators.required],
      }, { validator: this.checkIfMatchingPasswords('newPassword', 'confirmPassword') });
    } else {
      this.registerForm = this.fb.group({
        id: [null],
        oldPassword: [null, Validators.required],
        newPassword: [null, Validators.compose([Validators.required, PasswordValidator.strong])],
        confirmPassword: [null, Validators.required],
      }, { validator: this.checkIfMatchingPasswords('newPassword', 'confirmPassword') });
    }
  }

  ngOnInit() {

  }

  checkIfMatchingPasswords(passwordKey: string, passwordConfirmationKey: string) {
    return (group: FormGroup) => {
      const passwordInput = group.controls[passwordKey],
        passwordConfirmationInput = group.controls[passwordConfirmationKey];
      if (passwordInput.value !== passwordConfirmationInput.value) {
        return passwordConfirmationInput.setErrors({ notEquivalent: true });
      } else {
        return passwordConfirmationInput.setErrors(null);
      }
    };
  }

  onSubmit() {
    if (this.registerForm.valid) {
      this.registerForm.value.id = this.UserId;
      /*~~~~~~~~~~~~~~~ Start  Nidhi Bhosale 2026-03-30 PMSID(zota/netcore/cpos/cpos_web_angular): 9857*/
      // this.sharedService.customPostApi(API_ENDPOINTS.CHANGE_PASSWORD, this.registerForm.value).subscribe((t) => {
      const strReq = (this.aes.encrypt(JSON.stringify(this.registerForm.value)));
      this.sharedService.customPostApi(API_ENDPOINTS.RESET_PASSWORD, this.aes.encryptedString(strReq)).subscribe((t:any) => {
        /*~~~~~~~~~~~~~~~  End Nidhi Bhosale 2026-03-30 PMSID(zota/netcore/cpos/cpos_web_angular): 9857*/
        /*~~~~~~~~~~~~~~~ Satrt Tushar 2025-01-10 Gid.(zota/netcore/cpos/cpos_web_angular): #93*/
        //this.notification.success('Password Change Successfully');
        this.notification.success(t.message);
        /*~~~~~~~~~~~~~~~ end Tushar 2025-01-10 Gid.(zota/netcore/cpos/cpos_web_angular): #93*/
        this.registerForm.reset();
        if (this.IsLogout === true) {
          this.authService.logOut();
        }
        this.dialogRef.close(true);
      }, (error) => {
        /*~~~~~~~~~~~~~~~ Satrt Tushar 2025-01-10 Gid.(zota/netcore/cpos/cpos_web_angular): #93*/
        //this.notification.success('Password Change failed');
        this.notification.error(error.error);
        /*~~~~~~~~~~~~~~~ End Tushar 2025-01-10 Gid.(zota/netcore/cpos/cpos_web_angular): #93*/
      });
    } else {
      FormServices.focusFormValidationErrors(this.registerForm);
    }
  }

  onCancel() {
    this.dialogRef.close();
  }

}
